<span class="time">{{hours}}:{{minutes}}:{{seconds}}</span>